export default {"src":"/_next/static/media/download-on-app-store-white.f226bf51.svg","height":40,"width":120,"blurWidth":0,"blurHeight":0};